import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/pages/layout';
import Login from '../components/Login.vue'
import ChatRoom from '../pages/views/offline_course/detail/interaction.vue'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/reportIndex',
      component: () => import('@/pages/views/H5/indexReport.vue'),
    },
    {
      path: '/reportAll',
      component: () => import('@/pages/views/H5/reportAll.vue'),
    },
    {
      path: '/reportCity',
      component: () => import('@/pages/views/H5/reportCity.vue'),
    },
    {
      path: '/reportReseller',
      component: () => import('@/pages/views/H5/reportReseller.vue'),
    },
    {
      path: '/reportDoor',
      component: () => import('@/pages/views/H5/reportDoor.vue'),
    },
    {
      path: '/reportAthlete',
      component: () => import('@/pages/views/H5/reportAthlete.vue'),
    },
    {
      path: '/reportDetail',
      component: () => import('@/pages/views/H5/reportDetail.vue'),
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/chatRoom',
      component: ChatRoom
    },
    {
      path: '/login',
      component: Login,
      meta: { menuKey: 'Login', title: 'Login' }
    },
    {
      path: '/pages',
      redirect: '/pages/home',
      component: Layout,
      children: [
        {
          path: 'home',
          component: () => import('@/pages/views/Home.vue'),
          meta: {menuKey: 'home',   title: 'home' }
        },
        {
          path: 'courseManage',
          component: () => import('@/pages/views/course/courseManage.vue'),
          meta: {menuKey: 'courseManage',   title: 'courseManage' }
        },
        {
          path: 'courseEdit',
          component: () => import('@/pages/views/course/courseEdit.vue'),
          meta: {menuKey: 'courseManage',   title: 'courseManage' }
        },
        {
          path: 'courseEditFAB',
          component: () => import('@/pages/views/course/courseEditFAB.vue'),
          meta: {menuKey: 'courseEditFAB',   title: 'courseManage' }
        },
        {
          path: 'courseAssign',
          component: () => import('@/pages/views/course/courseAssign.vue'),
          meta: {menuKey: 'courseAssign',   title: 'courseManage' }
        },
        {
          path: 'courseCollectionManage',
          component: () => import('@/pages/views/course/courseCollectionManage.vue'),
          meta: {menuKey: 'courseCollectionManage',   title: 'courseCollectionManage' }
        },
        {
          path: 'courseCollectionEdit',
          component: () => import('@/pages/views/course/courseCollectionEdit.vue'),
          meta: {menuKey: 'courseCollectionManage',   title: 'courseCollectionManage' }
        },
        {
          path: 'offlineCourseCreate',
          component: () => import('@/pages/views/offline_course/offlineCourseCreate.vue'),
          meta: {menuKey: 'offlineCourseCreate',   title: 'offlineCourseCreate' }
        },
        {
          path: 'offlineCourseFinishedList',
          component: () => import('@/pages/views/offline_course/offlineCourseFinishedList.vue'),
          meta: {menuKey: 'offlineCourseFinishedList',   title: 'offlineCourseFinishedList' }
        },
        {
          path: 'offlineCourseEdit',
          component: () => import('@/pages/views/offline_course/offlineCourseEdit.vue'),
          meta: {menuKey: 'offlineCourseEdit',   title: 'offlineCourseEdit' }
        },
        {
          path: 'offlineCourseOn',
          component: () => import('@/pages/views/offline_course/offlineCourseOn.vue'),
          meta: {menuKey: 'offlineCourseOn',   title: 'offlineCourseOn' }
        },
        {
          path: 'offlineCourseOff',
          component: () => import('@/pages/views/offline_course/offlineCourseOff.vue'),
          meta: {menuKey: 'offlineCourseOff',   title: 'offlineCourseOff' }
        },
        {
          path: 'offlineCoursePermission',
          component: () => import('@/pages/views/offline_course/offlineCoursePermission.vue'),
          meta: {menuKey: 'offlineCoursePermission',   title: 'offlineCoursePermission' }
        },
        {
          path: 'offlineCourseType',
          component: () => import('@/pages/views/offline_course/offlineCourseType.vue'),
          meta: {menuKey: 'offlineCourseType',   title: 'offlineCourseType' }
        },
        {
          path: 'categoryManage',
          component: () => import('@/pages/views/course/categoryManage.vue'),
          meta: {menuKey: 'categoryManage',   title: 'categoryManage' }
        },
        {
          path: 'categoryEdit',
          component: () => import('@/pages/views/course/categoryEdit.vue'),
          meta: {menuKey: 'categoryManage',   title: 'categoryManage' }
        },
        {
          path: 'tagManage',
          component: () => import('@/pages/views/course/tagManage.vue'),
          meta: {menuKey: 'tagManage',   title: 'tagManage' }
        },
        {
          path: 'tagEdit',
          component: () => import('@/pages/views/course/tagEdit.vue'),
          meta: {menuKey: 'tagManage',   title: 'tagManage' }
        },
        {
          path: 'competitionManage',
          component: () => import('@/pages/views/competition/competitionManage.vue'),
          meta: {menuKey: 'competitionManage',   title: 'competitionManage' }
        },
        {
          path: 'competitionEdit',
          component: () => import('@/pages/views/competition/competitionEdit.vue'),
          meta: {menuKey: 'competitionManage',   title: 'competitionManage' }
        },
        {
          path: 'competitionType',
          component: () => import('@/pages/views/competition/competitionTypeManage.vue'),
          meta: {menuKey: 'competitionType',   title: 'competitionManage' }
        },
        {
          path: 'competitionTypeEdit',
          component: () => import('@/pages/views/competition/competitionTypeEdit.vue'),
          meta: {menuKey: 'competitionType',   title: 'competitionManage' }
        },
        {
          path: 'workManage',
          component: () => import('@/pages/views/works/workManage.vue'),
          meta: {menuKey: 'workManage',   title: 'workManage' }
        },
        {
          path: 'workEdit',
          component: () => import('@/pages/views/works/workEdit.vue'),
          meta: {menuKey: 'workManage',   title: 'workManage' }
        },
        {
          path: 'workAudit',
          component: () => import('@/pages/views/works/workAudit.vue'),
          meta: {menuKey: 'workManage',   title: 'workManage' }
        },
        {
          path: 'topicManage',
          component: () => import('@/pages/views/topic/topicManage.vue'),
          meta: {menuKey: 'topicManage',   title: 'topicManage' }
        },
        {
          path: 'titbitManage',
          component: () => import('@/pages/views/titbits/titbitManage.vue'),
          meta: {menuKey: 'titbitManage',   title: 'titbitManage' }
        },
        {
          path: 'messageManage',
          component: () => import('@/pages/views/message/messageManage.vue'),
          meta: {menuKey: 'messageManage',   title: 'messageManage' }
        },
        {
          path: 'subjectManage',
          component: () => import('@/pages/views/subject/subjectManage.vue'),
          meta: {menuKey: 'subjectManage',   title: 'subjectManage' }
        },
        {
          path: 'activityManage',
          component: () => import('@/pages/views/activity/activityManage.vue'),
          meta: {menuKey: 'activityManage',   title: 'activityManage' }
        },
        {
          path: 'activityEdit',
          component: () => import('@/pages/views/activity/activityEdit.vue'),
          meta: {menuKey: 'activityManage',   title: 'activityManage' }
        },
        {
          path: 'activityDetail',
          component: () => import('@/pages/views/activity/activityDetail.vue'),
          meta: {menuKey: 'activityManage',   title: 'activityManage' }
        },
        {
          path: 'activityCheck',
          component: () => import('@/pages/views/activity/activityCheck.vue'),
          meta: {menuKey: 'activityManage',   title: 'activityManage' }
        },
        {
          path: 'userManage',
          component: () => import('@/pages/views/userManage.vue'),
          meta: {menuKey: 'userManage',   title: 'userManage' }
        },
        {
          path: 'userEdit',
          component: () => import('@/pages/views/userEdit.vue'),
          meta: {menuKey: 'userManage',   title: 'userManage' }
        },
        {
          path: 'doorManage',
          component: () => import('@/pages/views/systemDoor.vue'),
          meta: {menuKey: 'doorManage',   title: 'doorManage' }
        },
        {
          path: 'systemDoorDetail',
          component: () => import('@/pages/views/systemDoorDetail.vue'),
          meta: {menuKey: 'doorManage',   title: 'systemDoorDetail' }
        },
        {
          path: 'systemManage',
          component: () => import('@/pages/views/SystemManage.vue'),
          meta: {menuKey: 'systemManage',   title: 'systemManage' }
        },
        {
          path: 'reportManage',
          component: () => import('@/pages/views/ReportManage.vue'),
          meta: {menuKey: 'reportManage',   title: 'reportManage' }
        },
        {
          path: 'liveManage',
          component: () => import('@/pages/views/live/liveManage.vue'),
          meta: {menuKey: 'liveManage',   title: 'liveManage' }
        },
        {
          path: 'liveAdd',
          component: () => import('@/pages/views/live/liveAdd.vue'),
          meta: {menuKey: 'liveManage',   title: 'liveAdd' }
        },
        {
          path: 'liveEdit',
          component: () => import('@/pages/views/live/liveEdit.vue'),
          meta: {menuKey: 'liveManage',   title: 'liveEdit' }
        },
        {
          path: 'liveSettings',
          component: () => import('@/pages/views/live/liveSettings.vue'),
          meta: {menuKey: 'liveSettings',   title: 'liveSetting' }
        },
        {
          path: 'commentManage',
          component: () => import('@/pages/views/course/commentManage.vue'),
          meta: {menuKey: 'commentManage',   title: 'commentManage' }
        },
        {
          path: 'bannerManage',
          component: () => import('@/pages/views/banner/bannerManage.vue'),
          meta: {menuKey: 'bannerManage',   title: 'bannerManage' }
        },
        {
          path: 'bannerEdit',
          component: () => import('@/pages/views/banner/bannerEdit.vue'),
          meta: {menuKey: 'bannerManage',   title: 'bannerManage' }
        },
        {
          path: 'loginTime',
          component: () => import('@/pages/views/report/loginTime.vue'),
          meta: {menuKey: 'loginTime',   title: 'loginTime' }
        },
        {
          path: 'searchReport',
          component: () => import('@/pages/views/report/searchReport.vue'),
          meta: {menuKey: 'searchReport',   title: 'searchReport' }
        },
        {
          path: 'courseReport',
          component: () => import('@/pages/views/report/courseReport.vue'),
          meta: {menuKey: 'courseReport',   title: 'courseReport' }
        },
        {
          path: 'examReport',
          component: () => import('@/pages/views/report/examReport.vue'),
          meta: {menuKey: 'examReport',   title: 'examReport' }
        },
        {
          path: 'taskReport',
          component: () => import('@/pages/views/report/taskReport.vue'),
          meta: {menuKey: 'taskReport',   title: 'taskReport' }
        },
        {
          path: 'pointReport',
          component: () => import('@/pages/views/report/pointReport.vue'),
          meta: {menuKey: 'pointReport',   title: 'pointReport' }
        },
        {
          path: 'deleteReport',
          component: () => import('@/pages/views/report/deleteReport.vue'),
          meta: {menuKey: 'deleteReport',   title: 'deleteReport' }
        },
        {
          path: 'equipmentReport',
          component: () => import('@/pages/views/report/equipmentReport.vue'),
          meta: {menuKey: 'equipmentReport',   title: 'equipmentReport' }
        },
        {
          path: 'initialData',
          component: () => import('@/pages/views/report/initialData.vue'),
          meta: {menuKey: 'initialData',   title: 'initialData' }
        },
        {
          path: 'medalReport',
          component: () => import('@/pages/views/report/medalReport.vue'),
          meta: {menuKey: 'medalReport',   title: 'medalReport' }
        },
        {
          path: 'popupManage',
          component: () => import('@/pages/views/popup/popupManage.vue'),
          meta: {menuKey: 'popupManage',   title: 'popupManage' }
        },
        {
          path: 'popupEdit',
          component: () => import('@/pages/views/popup/popupEdit.vue'),
          meta: {menuKey: 'popupManage',   title: 'popupManage' }
        },
        {
          path: 'appBackground',
          component: () => import('@/pages/views/appBackground.vue'),
          meta: {menuKey: 'appBackground',   title: 'appBackground' }
        },
        {
          path: 'productManage',
          component: () => import('@/pages/views/points_store/productManage.vue'),
          meta: {menuKey: 'productManage',   title: 'pointsStore' }
        },
        {
          path: 'exchangeManage',
          component: () => import('@/pages/views/points_store/exchangeManage.vue'),
          meta: {menuKey: 'productManage',   title: 'pointsStore' }
        },
        {
          path: 'productEdit',
          component: () => import('@/pages/views/points_store/productEdit.vue'),
          meta: {menuKey: 'productManage',   title: 'pointsStore' }
        },
        {
          path: 'exchangeDetail',
          component: () => import('@/pages/views/points_store/exchangeDetail.vue'),
          meta: {menuKey: 'productManage',   title: 'pointsStore' }
        },
        {
          path: 'surveyList',
          component: () => import('@/pages/views/survey/surveyList.vue'),
          meta: {menuKey: 'surveyList',   title: 'survey' }
        },
        {
          path: 'surveyEdit',
          component: () => import('@/pages/views/survey/surveyEdit.vue'),
          meta: {menuKey: 'surveyList',   title: 'survey' }
        },
        {
          path: 'surveyPreview',
          component: () => import('@/pages/views/survey/surveyPreview.vue'),
          meta: {menuKey: 'surveyList',   title: 'survey' }
        },
        {
          path: 'surveyReport', //问卷报表-调查问卷报表
          component: () => import('@/pages/views/survey/surveyReport.vue'),
          meta: {menuKey: 'surveyList',   title: 'survey' }
        },
        {
          path: 'pendingWork',
          component: () => import('@/pages/views/knowledge/pendingWork.vue'),
          meta: {menuKey: 'pendingWork',   title: 'pendingWork' }
        },
        {
          path: 'editWork',
          component: () => import('@/pages/views/knowledge/editWork.vue'),
          meta: {menuKey: 'pendingWork',   title: 'knowledgeManage' }
        },
        {
          path: 'auditWork',
          component: () => import('@/pages/views/knowledge/auditWork.vue'),
          meta: {menuKey: 'pendingWork',   title: 'auditWork' }
        },
        {
          path: 'upWork',
          component: () => import('@/pages/views/knowledge/upWork.vue'),
          meta: {menuKey: 'upWork',   title: 'upWork' }
        },
        {
          path: 'workDetail',
          component: () => import('@/pages/views/knowledge/workDetail.vue'),
          meta: {menuKey: 'upWork',   title: 'workDetail' }
        },
        {
          path: 'downWork',
          component: () => import('@/pages/views/knowledge/downWork.vue'),
          meta: {menuKey: 'downWork',   title: 'downWork' }
        },
        {
          path: 'rejectedWork',
          component: () => import('@/pages/views/knowledge/rejectedWork.vue'),
          meta: {menuKey: 'rejectedWork',   title: 'rejectedWork' }
        },
        {
          path: 'knowledgeTagManage',
          component: () => import('@/pages/views/knowledge/tagManage.vue'),
          meta: {menuKey: 'knowledgeTagManage',   title: 'tagManage' }
        },
        {
          path: 'keywordManage',
          component: () => import('@/pages/views/knowledge/keywordManage.vue'),
          meta: {menuKey: 'keywordManage',   title: 'keywordManage' }
        },
        {
          path: 'avatarManage',
          component: () => import('@/pages/views/knowledge/avatarManage.vue'),
          meta: {menuKey: 'avatarManage',   title: 'avatarManage' }
        },
        {
          path: 'commentManage2',
          component: () => import('@/pages/views/knowledge/commentManage.vue'),
          meta: {menuKey: 'commentManage',   title: 'commentManage' }
        },
        {
          path: 'avatarEdit',
          component: () => import('@/pages/views/knowledge/avatarEdit.vue'),
          meta: {menuKey: 'avatarManage',   title: 'avatarManage' }
        },
        {
          path: 'topicTypeManage',
          component: () => import('@/pages/views/knowledge/topicTypeManage.vue'),
          meta: {menuKey: 'topicTypeManage',   title: 'topicTypeManage' }
        },
        {
          path: 'homeRecomParams',
          component: () => import('@/pages/views/knowledge/homeRecom.vue'),
          meta: {menuKey: 'homeRecom',   title: 'homeRecom' }
        },
        {
          path: 'storehouseManage',
          component: () => import('@/pages/views/product/productManage.vue'),
          meta: {menuKey: 'storehouseManage',   title: 'storehouseManage' }
        },
        {
          path: 'importLog',
          component: () => import('@/pages/views/product/importLog.vue'),
          meta: {menuKey: 'importLog',   title: 'importLog' }
        },
        {
          path: 'productKeywordManage',
          component: () => import('@/pages/views/product/keywordManage.vue'),
          meta: {menuKey: 'productKeywordManage',   title: 'productKeywordManage' }
        },
        {
          path: 'storehouseEdit',
          component: () => import('@/pages/views/product/productEdit.vue'),
          meta: {menuKey: 'storehouseEdit',   title: 'storehouseEdit' }
        },
        {
          path: 'storehouseDetail',
          component: () => import('@/pages/views/product/productDetail.vue'),
          meta: {menuKey: 'productDetail',   title: 'storehouseEdit' }
        },
        {
          path: 'hotwordManage',
          component: () => import('@/pages/views/hotwordManage.vue'),
          meta: {menuKey: 'hotwordManage',   title: 'hotwordManage' }
        },
        {
          path: 'noticeManage',
          component: () => import('@/pages/views/notice/noticeManage.vue'),
          meta: {menuKey: 'noticeManage',   title: 'noticeManage' }
        },
        {
          path: 'noticeEdit',
          component: () => import('@/pages/views/notice/noticeEdit.vue'),
          meta: {menuKey: 'noticeEdit',   title: 'noticeManage' }
        },
        {
          path: 'noticeDetail',
          component: () => import('@/pages/views/notice/noticeDetail.vue'),
          meta: {menuKey: 'noticeDetail',   title: 'noticeManage' }
        },
        {
          path: 'pushManage',
          component: () => import('@/pages/views/push/pushManage.vue'),
          meta: {menuKey: 'pushManage',   title: 'pushManage' }
        },
        {
          path: 'pushSetting',
          component: () => import('@/pages/views/push/pushSetting.vue'),
          meta: {menuKey: 'pushManage',   title: 'pushManage' }
        },
        {
          path: 'dailyQuestion',
          component: () => import('@/pages/views/daily/dailyQuestion.vue'),
          meta: {menuKey: 'dailyQuestion',   title: 'dailyQuestion' }
        },
        {
          path: 'dailyManage',
          component: () => import('@/pages/views/daily/dailyManage.vue'),
          meta: {menuKey: 'dailyQuestion',   title: 'dailyQuestion' }
        },
        {
          path: 'ambassadorCategoryManage',
          component: () => import('@/pages/views/ambassador/ambassadorCategoryManage.vue'),
          meta: {menuKey: 'ambassadorCategoryManage',   title: 'ambassadorCategoryManage' }
        },
        {
          path: 'ambassadorCategoryEdit',
          component: () => import('@/pages/views/ambassador/ambassadorCategoryEdit.vue'),
          meta: {menuKey: 'ambassadorCategoryEdit',   title: 'ambassadorCategoryManage' }
        },
        {
          path: 'ambassadorManage',
          component: () => import('@/pages/views/ambassador/ambassadorManage.vue'),
          meta: {menuKey: 'ambassadorManage',   title: 'ambassadorManage' }
        },
        {
          path: 'otherAmbassadorManage',  //?categoryId=1 视觉陈列大使 ?categoryId=2 ND大使
          component: () => import('@/pages/views/ambassador/otherAmbassadorManage.vue'),
          meta: {menuKey: 'ambassadorManage',   title: 'ambassadorManage' }
        },
        {
          path: 'ambassadorEdit',
          component: () => import('@/pages/views/ambassador/ambassadorEdit.vue'),
          meta: {menuKey: 'ambassadorEdit',   title: 'ambassadorManage' }
        },
        {
          path: 'otherAmbassadorEdit',
          component: () => import('@/pages/views/ambassador/otherAmbassadorEdit.vue'),
          meta: {menuKey: 'ambassadorEdit',   title: 'ambassadorManage' }
        },
        {
          path: 'ambassadorReport',
          component: () => import('@/pages/views/ambassador/ambassadorReport.vue'),
          meta: {menuKey: 'ambassadorReport',   title: 'ambassadorReport' }
        },
        {
          path: 'athleteProfile',
          component: () => import('@/pages/views/athlete_profile2/athleteReport.vue'),
          meta: {menuKey: 'athleteReport',   title: 'athleteReport' }
        },
        {
          path: 'athleteExport',
          component: () => import('@/pages/views/athlete_profile2/athleteExport.vue'),
          meta: {menuKey: 'athleteDetail',   title: 'athleteDetail' }
        },
        {
          path: 'courseExport',
          component: () => import('@/pages/views/export/courseExport.vue'),
          meta: {menuKey: 'courseExport',   title: 'courseExport' }
        },
        {
          path: 'offCourseExport',
          component: () => import('@/pages/views/export/offCourseExport.vue'),
          meta: {menuKey: 'offCourseExport',   title: 'offCourseExport' }
        },
        {
          path: 'doorObtainedPointsExport',
          component: () => import('@/pages/views/export/doorObtainedPointsExport.vue'),
          meta: {menuKey: 'doorObtainedPointsExport',   title: 'doorObtainedPointsExport' }
        },
        {
          path: 'loginExport',
          component: () => import('@/pages/views/export/loginExport.vue'),
          meta: {menuKey: 'loginExport',   title: 'loginExport' }
        },
        {
          path: 'exportLog',
          component: () => import('@/pages/views/export/exportLog.vue'),
          meta: {menuKey: 'exportLog',   title: 'exportLog' }
        },
        {
          path: 'aiLog',
          component: () => import('@/pages/views/export/aiLog.vue'),
          meta: {menuKey: 'aiLog',   title: 'aiLog' }
        },
        {
          path: 'awardManage',
          component: () => import('@/pages/views/award/awardManage.vue'),
          meta: {menuKey: 'awardManage',   title: 'awardManage' }
        },
        {
          path: 'awardEdit',
          component: () => import('@/pages/views/award/awardEdit.vue'),
          meta: {menuKey: 'awardEdit',   title: 'awardManage' }
        },
        {
          path: 'signInTask',
          component: () => import('@/pages/views/signed_task/index.vue'),
          meta: {menuKey: 'signInTask',   title: 'signInTask' }
        },
        {
          path: 'totalSearchKeywordManage',
          component: () => import('@/pages/views/total_search/keywordManage.vue'),
          meta: {menuKey: 'totalSearchKeywordManage',   title: 'totalSearchKeywordManage' }
        },
        {
          path: 'totalSearchWordManage',
          component: () => import('@/pages/views/total_search/wordManage.vue'),
          meta: {menuKey: 'totalSearchWordManage',   title: 'totalSearchWordManage' }
        },
        {
          path: 'totalSearchRange',
          component: () => import('@/pages/views/total_search/searchRange.vue'),
          meta: {menuKey: 'totalSearchRange',   title: 'totalSearchRange' }
        },
        {
          path: 'newsManage',
          component: () => import('@/pages/views/news/newsManage.vue'),
          meta: {menuKey: 'newsManage',   title: 'newsManage' }
        },
        {
          path: 'newsEdit',
          component: () => import('@/pages/views/news/newsEdit.vue'),
          meta: {menuKey: 'newsEdit',   title: 'newsManage' }
        },
        {
          path: 'themeCourseManage',
          component: () => import('@/pages/views/themeCourse/themeCourseManage.vue'),
          meta: {menuKey: 'themeCourseManage',   title: 'themeCourseManage' }
        },
        {
          path: 'themeCourseEdit',
          component: () => import('@/pages/views/themeCourse/themeCourseEdit.vue'),
          meta: {menuKey: 'themeCourseEdit',   title: 'themeCourseManage' }
        },
        {
          path: 'recommendCourse',
          component: () => import('@/pages/views/recommendCourse/recommendCourse.vue'),
          meta: {menuKey: 'recommendCourse',   title: 'recommendCourse' }
        },
        {
          path: 'roleCategory',   //品类设置
          component: () => import('@/pages/views/role/roleCategory.vue'),
          meta: {menuKey: 'roleCategory',   title: 'roleCategory' }
        },
        {
          path: 'introductionAndCourseSetting', //认证简介及课程设置
          component: () => import('@/pages/views/role/introductionAndCourseSetting.vue'),
          meta: {menuKey: 'introductionAndCourseSetting',   title: 'introductionAndCourseSetting' }
        },
        {
          path: 'introductionAndCourseEdit', //编辑新增(没有菜单)
          component: () => import('@/pages/views/role/introductionAndCourseEdit.vue'),
          meta: {menuKey: 'introductionAndCourseEdit',   title: 'introductionAndCourseSetting' }
        },
        {
          path: 'authDetail', //
          component: () => import('@/pages/views/role/authDetail.vue'),
          meta: {menuKey: 'authDetail',   title: 'manageList' }
        },
        {
          path: 'manageList', //认证管理列表,有好几个,后面跟着 ?id=1 这样
          component: () => import('@/pages/views/role/manageList.vue'),
          meta: {menuKey: 'manageList',   title: 'manageList' }
        },
        {
          path: 'roleTaskManage', //角色任务集设置
          component: () => import('@/pages/views/role_task/roleTaskManage.vue'),
          meta: {menuKey: 'roleTaskManage',   title: 'roleTaskManage' }
        },
        {
          path: 'roleTaskEdit', //角色任务集编辑
          component: () => import('@/pages/views/role_task/roleTaskEdit.vue'),
          meta: {menuKey: 'roleTaskManage',   title: 'roleTaskManage' }
        },
        {
          path: 'rolePeopleManage', //角色人员管理
          component: () => import('@/pages/views/role_task/rolePeopleManage.vue'),
          meta: {menuKey: 'roleTaskManage',   title: 'roleTaskManage' }
        },
        {
          path: 'roleAmbassadorManage', //角色任务列表,有好几个,后面跟着 ?id=1 这样
          component: () => import('@/pages/views/role_task/roleAmbassadorManage.vue'),
          meta: {menuKey: 'roleTaskManage',   title: 'roleTaskManage' }
        },
        {
          path: 'courseTopManage', //全文检索课程置顶
          component: () => import('@/pages/views/courseTop/courseTopManage.vue'),
          meta: {menuKey: 'courseTopManage',   title: 'courseTopManage' }
        },
        {
          path: 'onboardingCourseManage', //入职课程列表
          component: () => import('@/pages/views/onboarding_course/onboardingManage.vue'),
          meta: {menuKey: 'onboardingCourse',   title: 'onboardingCourse' }
        },
        {
          path: 'onboardingCourseEdit', //入职课程新增编辑
          component: () => import('@/pages/views/onboarding_course/onboardingCourseEdit.vue'),
          meta: {menuKey: 'onboardingCourse',   title: 'onboardingCourse' }
        },
        {
          path: 'kpiImproveManage', //业绩提升建议
          component: () => import('@/pages/views/kpi_improve/kpiImproveManage.vue'),
          meta: {menuKey: 'kpiImprove',   title: 'kpiImprove' }
        },
        {
          path: 'kpiImproveEdit', //业绩提升建议编辑
          component: () => import('@/pages/views/kpi_improve/kpiImproveEdit.vue'),
          meta: {menuKey: 'kpiImprove',   title: 'kpiImprove' }
        },
        {
          path: 'kpiImproveDetail', //业绩提升建议详情
          component: () => import('@/pages/views/kpi_improve/kpiImproveDetail.vue'),
          meta: {menuKey: 'kpiImprove',   title: 'kpiImprove' }
        },
        {
          path: 'aiUserManage', //ai用户管理
          component: () => import('@/pages/views/ai/aiUserManage.vue'),
          meta: {menuKey: 'aiUserManage',   title: 'aiUserManage' }
        },
        {
          path: 'questionManage', //提问管理
          component: () => import('@/pages/views/qAndA/questionManage.vue'),
          meta: {menuKey: 'questionManage',   title: 'questionManage' }
        },
        {
          path: 'recommendList', //推荐列表
          component: () => import('@/pages/views/qAndA/recommendList.vue'),
          meta: {menuKey: 'recommendList',   title: 'recommendList' }
        },
        {
          path: 'questionEdit', //提问新增/编辑
          component: () => import('@/pages/views/qAndA/questionEdit.vue'),
          meta: {menuKey: 'questionManage',   title: 'questionManage' }
        },
        {
          path: 'totalTagManage', //标签管理
          component: () => import('@/pages/views/tag/tagManage.vue'),
          meta: {menuKey: 'totalTagManage',   title: 'tagManage' }
        },
        {
          path: 'appSetting', //APP端设置
          component: () => import('@/pages/views/app_setting/appSetting.vue'),
          meta: {menuKey: 'appSetting',   title: 'appSetting' }
        },
        {
          path: 'appRangeSetting', //APP范围设置
          component: () => import('@/pages/views/qAndA/rangeSetting.vue'),
          meta: {menuKey: 'rangeSetting',   title: 'rangeSetting' }
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js